import React from "react";
import AddButton from "@rjsf/core/lib/components/AddButton";
import { getUiOptions } from "@rjsf/core/lib/utils";

function BasicObjectFieldTemplate(props) {
  var idSchema = props.idSchema,
      TitleField = props.TitleField,
      DescriptionField = props.DescriptionField;

  var canExpand = function canExpand() {
    var formData = props.formData,
        schema = props.schema,
        uiSchema = props.uiSchema;

    if (!schema.additionalProperties) {
      return false;
    }

    var _getUiOptions = getUiOptions(uiSchema),
        expandable = _getUiOptions.expandable;

    if (expandable === false) {
      return expandable;
    } // if ui:options.expandable was not explicitly set to false, we can add
    // another property if we have not exceeded maxProperties yet


    if (schema.maxProperties !== undefined) {
      return Object.keys(formData).length < schema.maxProperties;
    }

    return true;
  };

  return /*#__PURE__*/React.createElement("fieldset", {
    id: props.idSchema.$id
  }, (props.uiSchema["ui:title"] || props.title) && /*#__PURE__*/React.createElement(TitleField, {
    id: props.idSchema.$id + "__title",
    title: props.title || props.uiSchema["ui:title"],
    required: props.required,
    formContext: props.formContext
  }), props.description && /*#__PURE__*/React.createElement(DescriptionField, {
    id: props.idSchema.$id + "__description",
    description: props.description,
    formContext: props.formContext
  }), props.properties.map(function (prop) {
    return prop.content;
  }), canExpand() && /*#__PURE__*/React.createElement(AddButton, {
    className: "object-property-expand",
    onClick: props.onAddClick(props.schema),
    disabled: props.disabled || props.readonly
  }));
}

export default BasicObjectFieldTemplate;